import { render, staticRenderFns } from "./2022-1-1.vue?vue&type=template&id=d7350124&scoped=true&"
import script from "./2022-1-1.vue?vue&type=script&lang=ts&"
export * from "./2022-1-1.vue?vue&type=script&lang=ts&"
import style0 from "./2022-1-1.vue?vue&type=style&index=0&id=d7350124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7350124",
  null
  
)

export default component.exports